import { useTranslation } from "react-i18next";

// Custom hook that returns properly typed translation function
const useTypedTranslation = () => {
  const { t, i18n } = useTranslation();

  // Cast the t function to have the correct type signature
  const translate = t as (key: string, options?: object) => string;

  return {
    translate,
    i18n,
    t,
  };
};
export default useTypedTranslation;
